import { createAction } from 'redux-actions';
import viasportBackend from '../service/viasportBackend';

export default createAction('LOAD_TAG_VALUES', async ({ tag, country}) => {
  const availableTagValues = await viasportBackend.getTagValues(tag, country);
  return availableTagValues;
});



// WEBPACK FOOTER //
// ./src/action/loadTagValues.js